/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import {
  toAbsoluteUrl,
  useIllustrationsPath
} from '../../../helpers'
import moment from 'moment'
import { NotificationData } from '../../../layout/components/header/Topbar'
import { useIntl } from 'react-intl'

interface HeaderNotificationsMenuProps {
  notificationData: NotificationData[];
  handleNotificationNavigate: (type: string) => void;
}
const HeaderNotificationsMenu: FC<HeaderNotificationsMenuProps> = ({
  notificationData,
  handleNotificationNavigate,
}) => {
  const intl = useIntl()

  moment.updateLocale('en', {
    relativeTime: {
      h: 'an hr',
      hh: '%d hrs',
    },
  })
  const illustrationPath = useIllustrationsPath('1.png')

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px'
      data-kt-menu='true'
    >
      <div
        className='d-flex flex-column bgi-no-repeat rounded-top'
        style={{ backgroundImage: `url('${toAbsoluteUrl('/media/misc/menu-header-bg.jpg')}')` }}
      >
        <h3 className='text-white fw-bold px-9 mt-10 mb-6'>
          {intl.formatMessage({ id: 'MENU.NOTIFICATIONS' })} <span className='fs-8 opacity-75 ps-3'>{notificationData.length} Total </span>
        </h3>
      </div>

      <div className='tab-content'>
        <div className='tab-pane fade show active' id='kt_topbar_notifications_1' role='tabpanel'>
          <div className='scroll-y mh-325px my-5 px-8'>
            {notificationData.length > 0 ? notificationData.map((alert, index) => {
              const notificationType = alert.event_type || alert.resource_type || 'notification'
              const { icon, color } = findColor(notificationType)
              return (
                <div key={`alert${index}`} className='  py-4'>
                  <div className='d-flex flex-column align-items-end'>
                    <div className='d-flex w-100 flex-column justify-content-start'>
                      <a href='#' className='fs-6 fw-bolder text-primary' onClick={() => handleNotificationNavigate(notificationType)}>
                        {alert.title}
                      </a>
                      <div className='fs-7 text-truncate text-dark' title={alert.message} style={{ maxWidth: '320px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                        {alert.message}
                      </div>
                    </div>
                    <div className='d-flex align-items-center justify-content-between w-100'>

                      <span className={`badge badge-light-${color} fs-9 text-end`}>{notificationType}</span>
                      <span className='badge badge-light fs-9 text-end'>{moment(alert.created_at).fromNow()}</span>
                    </div>
                  </div>


                </div>
              )
            }
            ) :
              <div className='tab-pane fade show active' id='kt_topbar_notifications_2' role='tabpanel'>
                <div className='d-flex flex-column px-9'>
                  <div className='pt-10 pb-0'>
                    <h3 className='text-dark text-center fw-bolder'>{intl.formatMessage({ id: 'MENU.NO_NOTIFICATIONS' })}</h3>

                  </div>

                  <div className='text-center px-4'>
                    <img className='mw-100 mh-200px' alt='transparency' src={illustrationPath} />
                  </div>
                </div>
              </div>
            }
          </div>


        </div>
      </div>
    </div>
  )
}

export { HeaderNotificationsMenu }

const findColor = (notificationType: string) => {
  let icon, color;
  switch (true) {
    case notificationType.includes('blacklisted') || notificationType.includes('disabled') || notificationType.includes('rejected'):
      icon = 'cross';
      color = 'danger';
      break;
    case notificationType.includes('whitelisted') || notificationType.includes('enabled') || notificationType.includes('approved'):
      icon = 'check';
      color = 'success'
      break;


    default:
      color = 'warning';
      icon = 'notification'
      break;
  }
  return { icon, color }
}
